export const IDLE = "idle";
export const LOADING = "loading";
export const SUCCEEDED = "succeeded";
export const FAILED = "failed";
export const NEEDS_REFRESH = "refresh needed";
export const CLEAR = "clear";
